var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircleLineWithBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FEE9EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 26.668C47.3638 26.668 53.3334 32.6375 53.3334 40.0013C53.3334 47.365 47.3638 53.3346 40.0001 53.3346C32.6363 53.3346 26.6667 47.365 26.6667 40.0013C26.6667 32.6375 32.6363 26.668 40.0001 26.668ZM40.0001 29.3346C34.109 29.3346 29.3334 34.1103 29.3334 40.0013C29.3334 45.8924 34.109 50.668 40.0001 50.668C45.8911 50.668 50.6667 45.8924 50.6667 40.0013C50.6667 34.1103 45.8911 29.3346 40.0001 29.3346ZM37.1717 35.2872L40.0001 38.1156L42.8285 35.2872C43.3491 34.7665 44.1934 34.7665 44.7141 35.2872C45.2347 35.8079 45.2347 36.6521 44.7141 37.1728L41.8857 40.0012L44.7142 42.8297C45.2349 43.3504 45.2349 44.1946 44.7142 44.7153C44.1935 45.236 43.3493 45.236 42.8286 44.7153L40.0001 41.8868L37.1716 44.7153C36.6509 45.236 35.8067 45.236 35.286 44.7153C34.7653 44.1946 34.7653 43.3504 35.286 42.8297L38.1145 40.0012L35.2861 37.1728C34.7654 36.6521 34.7654 35.8079 35.2861 35.2872C35.8068 34.7665 36.651 34.7665 37.1717 35.2872Z",
    fill: "#F5222D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleLineWithBackground);
export default __webpack_public_path__ + "static/media/close_circle_line_with_background.98d94edbe0efc4c6428d3c50771ab3f4.svg";
export { ForwardRef as ReactComponent };